// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"gamepad-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3 7H21V19H3V7Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 7V4C12 3.44772 12.4477 3 13 3H16M3 7V19H21V7H3Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M6 13H8M8 13H10M8 13V11M8 13V15M14 13H14.0035V13.004H14V13ZM16 11H16.0035V11.004H16V11ZM16 15H16.0035V15.004H16V15ZM18 13H18.0035V13.004H18V13Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-gamepad-1')
export default class Gamepad1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'gamepad-1',
    }
  }
}
